import { Component, OnInit } from '@angular/core';
import { DataService } from '../shared/dataservice.service';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {

  constructor(public _dataService:DataService) { }

  ngOnInit() {
    this._dataService.currPageName = "Projects";
    this._dataService.additionalPageDetails = "";
  }

}
